import { useQuery } from '@tanstack/react-query';
import { REPORT_POLL_INTERVAL_MS } from '@/hooks/useDataPolling/pollingConstants';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { isReportInProgress } from '@/utils/reportStatus';

export const RECENT_REPORTS_QUERY_KEY = 'reports.recentReports';
export const RECENT_REPORTS_LIMIT = 5;

export function useGetRecentReports() {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [RECENT_REPORTS_QUERY_KEY, { tenantId }],
    queryFn: async () => api.reports.listReports({ tenantId, page: 1, perPage: RECENT_REPORTS_LIMIT }),
    select: data => data.data.reports,
    enabled: !!tenantId,
    placeholderData: previousData => previousData,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    // Statuses have to stay live while a report runs, and the tile has no per-row polling of
    // its own: re-list until nothing in the list is still working.
    refetchInterval: query =>
      query.state.data?.data.reports.some(report => isReportInProgress(report.status))
        ? REPORT_POLL_INTERVAL_MS
        : false,
  });
}
